import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Router} from '@angular/router';
import {DictionaryService} from "@amlCore/services";
import {AbstractControl, FormArray,  FormControl, FormGroup} from "@angular/forms";
import {Subject} from "rxjs";
import {DetectTransactionSet} from "../../../models/detectTransaction.model";
import {CurrencyMapper} from "../../../mapper/currency.mapper";
import {DetectTransactionInputType, SettingsTransactionsService} from "../settingsTransactions.service";

@Component({
  selector: "app-detect-transaction-condition",
  templateUrl: "./detectTransactionCondition.component.html",
  styleUrls: ['./detectTransactionCondition.component.scss']
})

export class DetectTransactionConditionComponent implements OnInit, OnDestroy {
  @Input() isReadOnly;
  @Input() submitted = false;
  @Input() formGroupApp: FormGroup;
  @Input() dictionary: { [name: string]: Array<any>; } = {};
  data: DetectTransactionSet;
  inputType: string;
  currencyMapper = new CurrencyMapper();
  $destroy = new Subject();
  constructor(
    protected router: Router,
    protected dictSrv: DictionaryService,
    private service: SettingsTransactionsService) {

  }

  ngOnInit() {
    this.data = this.formGroupApp?.value;
    this.inputType = this.getInputType(this.data);
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  f(field: string): FormControl {
    return this.formGroupApp.get(field) as FormControl;
  }

  fArray(field: string): FormArray {
    return this.formGroupApp.get(field) as FormArray;
  }

  fGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  getInputType(data: DetectTransactionSet): DetectTransactionInputType{
    return this.service.getConditionType(data);
  }

  showCondition(): boolean{
    return this.data?.condition && !['purpose','varcharList', 'accountMask'].includes(this.inputType);
  }
}
